<template>
    <div class="mobile-nav-bar tw-flex tw-justify-between tw-items-center">
        <img class="mobile-nav-bar__logo" src="@/assets/mobile/nav-logo.png" />
        <div
            class="mobile-nav-bar__trigger tw-cursor-pointer tw-w-[0.5rem] tw-h-[0.5rem] tw-flex tw-justify-center tw-items-center"
            :class="{
                'is-expand': isExpandMenu,
            }"
            @click="
                () => {
                    isExpandMenu = !isExpandMenu
                }
            "
        >
            <span v-for="v in 3" :key="v"></span>
        </div>
        <!-- 下拉菜单 -->
        <transition name="el-zoom-in-top">
            <div class="mobile-nav-bar__menu tw-flex tw-flex-col" v-show="isExpandMenu">
                <router-link
                    tag="div"
                    :class="[
                        'mobile-nav-bar__menu-item tw-flex tw-justify-between tw-items-center',
                        { 'is-active': $route.name === menu.name },
                    ]"
                    v-for="menu in menuList"
                    :key="menu.name"
                    :to="menu.path"
                    @click.native="
                        () => {
                            isExpandMenu = false
                        }
                    "
                >
                    <span>{{ menu.meta.title === '微观世界' ? '首页' : menu.meta.title }}</span>
                    <i class="el-icon-arrow-right"></i>
                </router-link>
            </div>
        </transition>
        <!-- 全屏遮罩 -->
        <transition name="el-fade-in-linear">
            <div
                class="mobile-nav-bar__mask"
                v-if="isExpandMenu"
                @click="
                    () => {
                        isExpandMenu = false
                    }
                "
            ></div>
        </transition>
    </div>
</template>

<script>
import { routes } from '@/router/index.js'

export default {
    name: 'MobileNavBar',
    data() {
        return {
            isExpandMenu: false,
        }
    },
    computed: {
        menuList() {
            return routes.filter(route => route.path === '/mobile')?.[0]?.children || []
        },
    },
}
</script>

<style lang="less">
.mobile-nav-bar {
    width: 100%;
    height: 1.2rem;
    padding: 0 0.36rem 0 0.48rem;
    box-shadow: 0px 1px 6px 1px #eeeeee;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    &__logo {
        width: 2.1rem;
        height: auto;
    }

    &__trigger {
        position: relative;
        width: 0.5rem;
        height: 0.5rem;
        position: relative;
        transform: scale(0.85);

        > span {
            display: inline-block;
            width: 100%;
            height: 0.06rem;
            background-color: #535865;
            border-radius: 0.03rem;
            opacity: 1;
            position: absolute;
            left: 0;
            transform: rotate(0deg);
            transition: 0.25s ease-in-out;

            &:nth-child(1) {
                top: 0.06rem;
            }

            &:nth-child(2) {
                top: 0.22rem;
            }

            &:nth-child(3) {
                top: 0.39rem;
            }
        }

        &.is-expand {
            > span:nth-child(1),
            > span:nth-child(3) {
                width: 0.6rem;
                transform: rotate(45deg);
                top: 0.24rem;
                left: -0.04rem;
            }

            > span:nth-child(2) {
                width: 0%;
                opacity: 0;
            }

            > span:nth-child(3) {
                transform: rotate(-45deg);
            }
        }
    }

    &__menu {
        position: absolute;
        top: 1.2rem;
        left: 0;
        width: 100%;
        background-color: #f8f9fa;
        padding: 0.2rem 0;
        border-radius: 0 0 0.4rem 0.4rem;
        overflow: hidden;
        z-index: 99;

        &-item {
            color: #161d2f;
            font-size: 0.32rem;
            height: 0.9rem;
            line-height: 0.9rem;
            padding: 0 0.48rem;
            transition:
                color 0.3s ease,
                background-color 0.3s ease;
            position: relative;

            > i {
                color: #838892;
                font-size: 0.28rem;
            }

            &::before {
                content: '';
                display: inline-block;
                width: 0.08rem;
                height: 0.46rem;
                border-radius: 0.04rem;
                background-color: var(--color-primary);
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                transition: opacity 0.3s ease;
                opacity: 0;
            }

            &.is-active {
                color: var(--color-primary);
                background-color: #fff;

                &::before {
                    opacity: 1;
                }
            }
        }
    }

    &__mask {
        width: 100vw;
        height: calc(100vh - 1.2rem);
        background-color: rgba(0, 0, 0, 0.2);
        position: fixed;
        top: 1.2rem;
        left: 0;
        z-index: 98;
    }
}
</style>
